(function () {
  'use strict';

  // The section emits its own <script> tag per instance and the theme editor
  // re-injects it on section load — only the first execution wires anything up
  // (same pattern as chiputt-media-carousel.js).
  if (window.__chiputtBeforeAfterInit) return;
  window.__chiputtBeforeAfterInit = true;

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function initSlider(root) {
    var frame = root.querySelector('.before-after-slider__frame');
    var beforeWrap = root.querySelector('[data-before-wrap]');
    var handle = root.querySelector('[data-slider-handle]');
    if (!frame || !beforeWrap || !handle) return;

    // initAll and shopify:section:load can both reach the same element —
    // never double-bind it. Editor reloads inject fresh DOM without the flag.
    if (root.dataset.bafInit) return;
    root.dataset.bafInit = '1';

    // parseFloat(...) || 50 would swallow a legitimate 0 ("full before")
    var parsedDefault = parseFloat(root.getAttribute('data-default-position'));
    var defaultPos = isNaN(parsedDefault) ? 50 : parsedDefault;
    var dragging = false;
    var pendingX = null;
    var rafId = null;

    function setPosition(percent) {
      var pct = clamp(percent, 0, 100);
      beforeWrap.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', Math.round(pct));
    }

    function eventX(evt) {
      if (evt.touches && evt.touches.length) {
        return evt.touches[0].clientX;
      }
      return evt.clientX;
    }

    function positionFromX(x, rect) {
      var pct = ((x - rect.left) / rect.width) * 100;
      return clamp(pct, 0, 100);
    }

    function applyPendingMove() {
      rafId = null;
      if (pendingX === null) return;
      // Read first (layout is clean at frame start), then write —
      // at most one layout per frame, no forced synchronous reflow.
      var rect = frame.getBoundingClientRect();
      var x = pendingX;
      pendingX = null;
      setPosition(positionFromX(x, rect));
    }

    function onPointerMove(evt) {
      if (!dragging) return;
      evt.preventDefault();
      pendingX = eventX(evt);
      if (rafId === null) {
        rafId = requestAnimationFrame(applyPendingMove);
      }
    }

    function startDrag(evt) {
      dragging = true;
      // Document-level listeners exist only during a drag, so idle page
      // scrolling never dispatches through the non-passive touchmove handler.
      document.addEventListener('mousemove', onPointerMove);
      document.addEventListener('touchmove', onPointerMove, { passive: false });
      document.addEventListener('mouseup', endDrag);
      document.addEventListener('touchend', endDrag);
      document.addEventListener('touchcancel', endDrag);
      document.addEventListener('mouseleave', endDrag);
      setPosition(positionFromX(eventX(evt), frame.getBoundingClientRect()));
    }

    function endDrag() {
      dragging = false;
      // A pending rAF still applies the final recorded position.
      document.removeEventListener('mousemove', onPointerMove);
      document.removeEventListener('touchmove', onPointerMove);
      document.removeEventListener('mouseup', endDrag);
      document.removeEventListener('touchend', endDrag);
      document.removeEventListener('touchcancel', endDrag);
      document.removeEventListener('mouseleave', endDrag);
    }

    handle.addEventListener('mousedown', startDrag);
    handle.addEventListener('touchstart', startDrag, { passive: true });

    // Click anywhere on the frame to jump the handle there
    frame.addEventListener('click', function (evt) {
      if (evt.target === handle || handle.contains(evt.target)) return;
      setPosition(positionFromX(eventX(evt), frame.getBoundingClientRect()));
    });

    // Keyboard support for accessibility
    handle.addEventListener('keydown', function (evt) {
      // parseFloat(...) || defaultPos would jump from 0% back to the default
      var current = parseFloat(handle.style.left);
      if (isNaN(current)) current = defaultPos;
      var step = evt.shiftKey ? 10 : 2;
      if (evt.key === 'ArrowLeft' || evt.key === 'ArrowDown') {
        evt.preventDefault();
        setPosition(current - step);
      } else if (evt.key === 'ArrowRight' || evt.key === 'ArrowUp') {
        evt.preventDefault();
        setPosition(current + step);
      } else if (evt.key === 'Home') {
        evt.preventDefault();
        setPosition(0);
      } else if (evt.key === 'End') {
        evt.preventDefault();
        setPosition(100);
      }
    });

    // Set initial position
    setPosition(defaultPos);
  }

  function initAll() {
    document.querySelectorAll('[data-before-after-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when Shopify theme editor injects/reorders sections
  document.addEventListener('shopify:section:load', function (evt) {
    evt.target
      .querySelectorAll('[data-before-after-slider]')
      .forEach(initSlider);
  });
})();
